import { z } from 'zod';


/** Mirrors the server's `createAdminBodySchema` so errors surface before a round trip. */
export const inviteAdminFormSchema = z.object({
  name: z.string().trim().min(2, 'Enter their full name').max(80, 'That name is too long'),
  email: z.string().trim().toLowerCase().email('Enter a valid email address').max(160),
});

export type InviteAdminForm = z.infer<typeof inviteAdminFormSchema>;
